<template>
    <LoadingPanel
        :headline="t('common.componentCommentsHeadline')"
        :is-pending="isPending"
        :is-error="isError"
        :hide-content="isDataEmpty"
    >
        <template
            v-if="isDataEmpty"
            #context
        >
            <ColorBadge
                :color="StatusTypes[ConditionStatus.None].color"
                :text="t(StatusTypes[ConditionStatus.None].labelKey)"
                small
            />
        </template>
        <ExportComponentComments :data="data"/>
    </LoadingPanel>
</template>

<script setup lang="ts">
import LoadingPanel from '@/components/panel/LoadingPanel.vue'
import { useTransformerId } from '@/composables/useTransformerId'
import { useI18n } from 'vue-i18n'
import { ConditionStatus, StatusTypes } from '@/configuration/status/condition-status'
import ColorBadge from '@/components/badge/ColorBadge.vue'
import ExportComponentComments from '@/components/comments/ExportComponentComments.vue'
import { useTransformerGeneralCommentsQuery } from '@/api/queries/transformers/general-comments/useTransformerGeneralCommentsQuery'
import { computed } from 'vue'

const { t } = useI18n()
const transformerId = useTransformerId()

const { data, isPending, isError } = useTransformerGeneralCommentsQuery(transformerId)

const isDataEmpty = computed(() => !data.value || data.value.length === 0)

</script>
